import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";
export const updateBannerFunc = createAsyncThunk(
  "updateBanner",
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await api.put(
        `dashboard/general-settings/banners/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const updateBannerSlicer = createSlice({
  name: "updateBanner",
  initialState: {
    loading: false,
    data: [],
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateBannerFunc.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.apiErrors = {};
    });
    builder.addCase(updateBannerFunc.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.apiErrors = action.payload?.errors || {};
    });
    builder.addCase(updateBannerFunc.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.successMessage = action.payload?.message || "";
    });
  },
});

export default updateBannerSlicer.reducer;
